import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { AuthProvider, useAuth } from './hooks/useAuth';
import Layout from './components/layout/Layout';

// Auth
import LoginPage          from './pages/auth/LoginPage';
import ChangePasswordPage from './pages/auth/ChangePasswordPage';

// M16 Users
import UsersListPage  from './pages/users/UsersListPage';
import CreateUserPage from './pages/users/CreateUserPage';
import EditUserPage   from './pages/users/EditUserPage';
import RolesPage      from './pages/users/RolesPage';
import AuditLogPage   from './pages/users/AuditLogPage';
import LeadsPage      from './pages/leads/LeadsPage';

// Dashboard
import DashboardPage  from './pages/DashboardPage';

// Phase 1 Masters
import MaterialsPage  from './pages/materials/MaterialsPage';
import MachineryPage  from './pages/machinery/MachineryPage';
import ToolsPage      from './pages/tools/ToolsPage';
import HRPage         from './pages/hr/HRPage';

// M07 Activity Master
import ActivityPage    from './pages/activity/ActivityPage';

// M08 Estimation
import EstimatePage      from './pages/estimation/EstimatePage';

//M09 Project Management
import ProjectPage from './pages/projects/ProjectPage';
import ActivityPlanPage from './pages/projects/ActivityPlanPage';
//import ActivityBuilderPage from './pages/projects/ActivityBuilderPage';

import MaterialSpecPage from './pages/estimation/MaterialSpecPage';
import MaterialIndentPage from './pages/projects/MaterialIndentPage';
import ResourcePlanPage from './pages/projects/ResourcePlanPage';
import QuotationTemplatePage from './pages/quotation/QuotationTemplatePage';




// Add forms

const ProtectedRoute = () => {
  const { isAuthenticated, isLoading, user } = useAuth();
  if (isLoading) return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4" />
        <p className="text-gray-500 text-sm">Loading RB-PMS...</p>
      </div>
    </div>
  );
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (user?.must_change_pwd) return <Navigate to="/change-password" replace />;
  return <Layout><Outlet /></Layout>;
};

const AppRoutes = () => (
  <Routes>
    <Route path="/login"           element={<LoginPage />} />
    <Route path="/change-password" element={<ChangePasswordPage />} />

    <Route element={<ProtectedRoute />}>
      <Route path="/"              element={<Navigate to="/dashboard" replace />} />

      {/* Dashboard */}
      <Route path="/dashboard"     element={<DashboardPage />} />

      {/* M16 Users */}
      <Route path="/users"         element={<UsersListPage />} />
      <Route path="/users/create"  element={<CreateUserPage />} />
      <Route path="/users/:id/edit" element={<EditUserPage />} />
      <Route path="/roles"         element={<RolesPage />} />
      <Route path="/audit"         element={<AuditLogPage />} />

      {/* Phase 1 Masters */}
      <Route path="/materials"     element={<MaterialsPage />} />
      <Route path="/machinery"     element={<MachineryPage />} />
      <Route path="/tools"         element={<ToolsPage />} />
      <Route path="/hr"            element={<HRPage />} />

      {/* M07 Activity Master */}
      <Route path="/activities"     element={<ActivityPage />} />

      <Route path="/material-spec" element={<MaterialSpecPage />} />
      {/* M08 Estimation */}
      <Route path="/estimation"    element={<EstimatePage />} />
      <Route path="/leads" element={<LeadsPage />} />
      <Route path="/projects" element={<ProjectPage />} />
      <Route path="/activity-plan" element={<ActivityPlanPage />} />
      <Route path="/material-indents" element={<MaterialIndentPage />} />
      <Route path="/resource-plan" element={<ResourcePlanPage />} />
      <Route path="/quotation-template" element={<QuotationTemplatePage />} />

      {/* Add forms */}
    </Route>

    <Route path="*" element={<Navigate to="/" replace />} />
  </Routes>
);

const App = () => (
  <BrowserRouter>
    <AuthProvider>
      <AppRoutes />
    </AuthProvider>
  </BrowserRouter>
);

export default App;
